var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sms d-flex"},[_c('Left',{on:{"init":_vm.init},model:{value:(_vm.chat),callback:function ($$v) {_vm.chat=$$v},expression:"chat"}}),(!_vm.isMobile)?_c('Right',{attrs:{"chat":_vm.chat}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }